import { setGoals } from 'modules/overlay-v2/store/game-info/game-info';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';
import { DivProps } from 'typings';
import usePopupMessenger from 'modules/overlay-v2/ui/hooks/use-popup-messenger';
import useGameInfo from 'modules/overlay-v2/ui/hooks/use-game-info';
import Counter from './counter';

interface IProps extends DivProps {
  teamIndex: number;
}

function Score(props: IProps) {
  const dispatch = useDispatch<AppDispatch>();
  const { teamIndex, ...rest } = props;

  const { goals } = useGameInfo();
  const { send } = usePopupMessenger();
  const prefix = teamIndex === 0 ? 'first' : 'second';

  const teamScore = useMemo(() => {
    return goals?.[prefix] ?? 0;
  }, [goals, prefix]);

  const handleChangeScore = useCallback(
    (newValue: number) => {
      dispatch(setGoals({ [prefix]: newValue }));
      send({ type: 'setGoals', [prefix]: newValue });
    },
    [dispatch, send, prefix],
  );

  return <Counter setValue={handleChangeScore} value={teamScore} title={'Счёт'} titleWidth={40} {...rest} />;
}

export default Score;
